import { DependencyList, useEffect } from "react";

export const useMutationObserver = (callback: () => void, deps: DependencyList) => {
  
  useEffect(() => {
    const observer = new MutationObserver(() => {
      callback()
    });
    observer.observe(document.body, {
      childList: true,
      subtree: true,
      attributes: true
    });

    return () => {
      observer.disconnect();
    }
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, deps);
}